import { get, find, findIndex, nth, includes } from 'lodash';
import PageKey from '../../../lib/page-data/key';

export const isLoadingAlbum = (state, albumId) => {
  const events = get(state, 'media.albums.loadingAlbums', []);
  return includes(events, albumId);
};

export const getAlbumLoadingError = (state, albumId) => {
  const errors = get(state, 'media.albums.albumLoadingErrors', []);
  return find(errors, { albumId });
};

export const getAlbum = (state, albumId) => {
  const albums = get(state, 'media.albums.albums', []);
  return find(albums, { id: albumId });
};

export const getAlbumList = (state, teamId, page, search) => {
  const key = search ? `${teamId}-${page}-${search}` : `${teamId}-${page}`;
  return get(state, `media.albums.albumLists[${key}]`, []);
};

export const getAlbumListPageLoadingError = (state, teamId, page, search) => {
  const key = search ? `${teamId}-${page}-${search}` : `${teamId}-${page}`;
  return get(state, `media.albums.loadingErrors[${key}]`);
};

export const getAlbumListPagination = (state, teamId = 0, search) => {
  const key = search ? `${teamId}-${search}` : teamId;
  return get(state, `media.albums.pagination[${key}]`);
};

export const hasLoadedAlbumList = (state, clubId, teamId, page, search) => {
  const key = new PageKey(clubId, 'album_list', { teamId, page, search });
  return includes(get(state, `activityStream.loaded`), key.toString());
};

export const getImage = (state, albumId, imageId) => {
  const album = getAlbum(state, albumId);
  if (!album) {
    return null;
  }

  return find(album.images, { id: imageId });
};

export const nextImage = (state, albumId, imageId) => {
  const album = getAlbum(state, albumId);
  if (!album || album.images.length === 1) {
    return null;
  }

  const currentIndex = findIndex(album.images, { id: imageId });

  if (currentIndex + 1 === album.images.length) {
    return nth(album.images, 0);
  }

  return nth(album.images, currentIndex + 1);
};

export const prevImage = (state, albumId, imageId) => {
  const album = getAlbum(state, albumId);
  if (!album || album.images.length === 1) {
    return null;
  }

  const currentIndex = findIndex(album.images, { id: imageId });
  return nth(album.images, currentIndex - 1);
};
